import { motion } from "framer-motion";
import { useSite } from "@/App";

// Full-width Cooling/Heating split feature band. The graphic contains its own
// COOLING SERVICES / HEATING SERVICES / LEARN MORE labels. Left half links to
// the Cooling section, right half to the Heating section of the Services tab.
export default function SplitGraphic() {
  const { scrollToId } = useSite();

  return (
    <section className="relative bg-[#101317] py-14 md:py-20">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mx-auto w-full max-w-3xl px-4"
      >
        <div className="relative w-full">
          <img
            src="/split-cooling-heating.png"
            alt="Cooling services and Heating services"
            className="block w-full h-auto select-none"
            draggable={false}
          />
          {/* Clickable halves */}
          <button
            data-testid="split-cooling-link"
            type="button"
            aria-label="View Cooling services"
            onClick={() => scrollToId("cooling")}
            className="absolute inset-y-0 left-0 w-1/2 focus-gold cursor-pointer"
          />
          <button
            data-testid="split-heating-link"
            type="button"
            aria-label="View Heating services"
            onClick={() => scrollToId("heating")}
            className="absolute inset-y-0 right-0 w-1/2 focus-gold cursor-pointer"
          />
        </div>
      </motion.div>
    </section>
  );
}
